import { Injectable, Inject, OnInit, OnDestroy } from '@angular/core';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IAuthorizationType } from './IAuthorizationType';
import { LookupState, getAuthorizationTypesLookup } from './store/reducers';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserAuthorizationTypeLookupService implements OnDestroy {
  public items: Array<IAuthorizationType>;
  uri = `${environment.apiLocation}/AuthType`;
  subscription: Subscription;

  ngOnDestroy (): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.log.debug({ type: 'UserAuthorizationTypeLookupService:ngOnDestroy' });
  }
  constructor(
    @Inject(HttpClient) private http: HttpClient,
    @Inject(LoggingService) private log: LoggingService,
  ) {
    this.log.debug({
      type: 'UserAuthorizationTypeLookupService:constructor',
      uri: this.uri
    });
  }

  public getAuthorizationTypes (): Observable<Array<IAuthorizationType>> {
    this.log.verbose({
      type: 'UserAuthorizationTypeLookupService:getAuthorizationTypes',
      uri: this.uri
    });
    return this.http.get<Array<IAuthorizationType>>(this.uri);
  }
}
